// collaboratorV2 app component variants
export const COLLABORATOR_V2_SEARCH_WITH_SELECTED_ITEMS =
  "search_dropdown_list";
export const COLLABORATOR_V2_ADD_EDIT_MODAL = "add_edit_modal";
export const COLLABORATOR_V2_LIST_WITH_MODAL = "list_with_modal";

// itemType map with respect to searchListTypes

export const SEARCH_LIST_TYPE_COLLABORATOR_TYPE_MAP = {
  STUDENT: ["PROJECT_GROUP_STUDENTS_POOL"],
  SUPERVISOR: ["ORGANIZATION_STAFF"],
};

export const COLLABORATOR_TYPES = ["STUDENT", "SUPERVISOR"];

export const EMAIL_EXIST_WARNING_CODE = "TD/UPDUSR/002";
export const DISPOSABLE_EMAIL_WARNING_CODE = "TD/SIGNUP/002";
export const INVALID_EMAIL_WARNING_CODE = "TD/UPDUSR/003";
export const MULTI_ACCESS_IDENTITY_NOT_FOUND_WARNING_CODE = "TD/SIGNUP/003";

export const CAS_EXTERNAL_COLLABORATOR_DESIGNATION = "7";
